import { render } from "./AgentBonus.vue?vue&type=template&id=64d7cfd9&scoped=true"
import script from "./AgentBonus.vue?vue&type=script&lang=js"
export * from "./AgentBonus.vue?vue&type=script&lang=js"

import "./AgentBonus.vue?vue&type=style&index=0&id=64d7cfd9&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d7cfd9"]])

export default __exports__